/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PesaChamaOutput { 
    savingProductCycleId?: number;
    savingProductId?: number;
    creditUnionId?: number;
    name?: string | null;
    isPublic?: boolean;
    savingProductName?: string | null;
    amount?: number;
    periodType?: string | null;
    numberOfContributionPerCycle?: number;
    cycleIsActive?: boolean;
    tenantId?: number;
    availableCapacity?: number;
}

